export function resolveQrRoute({ qrId, qrRecord, user, isAdmin }) {
  const isQrLinked = Boolean(
    qrRecord?.linked ||
    qrRecord?.qrCodeId ||
    qrRecord?.linkedRegistrationId ||
    qrRecord?.vehicleNumber ||
    qrRecord?.registrationId
  );

  if (qrId && isQrLinked) {
    return {
      type: 'alert',
      to: `/alert/qr/${encodeURIComponent(qrId)}`,
    };
  }

  if (!user) {
    return {
      type: 'login',
      to: '/login',
    };
  }

  if (!qrId && !isAdmin) {
    return {
      type: 'alert',
      to: '/alert/DEMO123',
    };
  }

  return {
    type: 'register',
  };
}
